'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../sections/template-cart');

require('../../styles/templates/cart.scss');

(0, _themeSections.load)(['template-cart']);